import typeCheck from 'common/util/typeCheck';
import { SR_API_ACTION_HOUSEHOLD_GET_BY_USER_ID } from 'api/actionTypes';

export default async function getHouseholdByUserId({ state, apiClient }, userId) {
  typeCheck('userId::PositiveNumber', userId);

  const result = await apiClient.postWithState({
    action: SR_API_ACTION_HOUSEHOLD_GET_BY_USER_ID,
    state: state,
    queryId: String(userId),
    payload: {
      userId,
    },
    onSuccess(household) {
      state.set(['household', 'byUserId', userId], household);
      return household;
    },
  });

  return result;
}
